import React, { useEffect, useRef, useState } from "react";
import BaseUrl from "../../base-api";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { handleAxiosError } from "../Utility/handleAxiosError";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { validateStep, getStepStatus } from "../utils/skillCoursesValidation";
import {
  validateAlphabetsWithSpace,
  validateNumeric,
  validateAlphaNumeric,
  validateName,
  validateAddress,
  validateEmail,
  validateMobile,
  validatePincode
} from "../utils/inputValidations";
import FormField from "../utils/FormField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const SkillCourses = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
const topRef = useRef(null);

const HEADER_OFFSET = 250; 

const scrollToTop = () => {

  if (window.innerWidth > 768) {
  const topY = topRef.current?.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({
    top: topY > 0 ? topY : 0,
    behavior: "smooth",
  });
}
};


  const [isExServiceman, setIsExServiceman] = useState(""); 
  const shouldLoadForm = isExServiceman === "Yes";

  const [formData, setFormData] = useState({
    pppIdEnabled: false,
    forceNumber: "",
    forceName: "",
    service: "",
    type: "",
    rank: "",
    fullName: "",
    medicalCategory: "",
    dischargeDate: "",
    dischargeBookNo: "",
    unitRetired: "",
    fatherName: "",
    motherName: "",
    dob: "",
    state: "",
    district: "",
    tehsil: "",
    village: "",
    address: "",
    pinCode: "",
    email: "",
    mobile: "",
    altMobile: "",
    otp: "",
    gender: "",             
    maritalStatus: "", 
    pppId: "",
    memberId: "",
  });

  const [qualificationDocs, setQualificationDocs] = useState({
    '8th': null,
    '10th': null,
    '12th': null,
    'Graduation': null,
    'Professional Course (if any)': null
  });

  const [dischargeFile, setDischargeFile] = useState(null);
  const [militaryCourseFile, setMilitaryCourseFile] = useState(null);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [tehsils, setTehsils] = useState([]);
  const [forces, setForces] = useState([]);
  const [services, setServices] = useState([]);
  const [types, setTypes] = useState([]);
  const [ranks, setRanks] = useState([]);
  const [medical, setMedical] = useState([]);
  const [genders, setGenders] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [casteCategories, setCasteCategories] = useState([]);
  const [Qualifications, setQualifications] = useState([]);
  const [Engagements, setEngagements] = useState([]);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState("");
  const [pppOtp, setPppOtp] = useState("");
  const [pppVerified, setPppVerified] = useState(false);
  const [pppOtpSent, setPppOtpSent] = useState(false);
  const [pppTxn, setPppTxn] = useState("");
  const [pppSuccessMessage, setPppSuccessMessage] = useState("");
  const [pppErrors, setPppErrors] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

const skillCourses=["Leather / Cutter Footwear","Textiles / Knitting Machine Operator – Flat Bed Knitting","ITATeS / Data Entry Operator","Automotive Assembly Technician","Automotive Welding Machine Operator (Manual and Robotics)","Automotive Electrician","Automotive Body Painting Operator","Electric Vehicle Assembly Operator","Electric Vehicle Assembly Technician","Electric Vehicle Maintenance Technician","Electric Vehicle Service Technician","Solar PV Installer (SURYA MITRA)","Solar PV Installer (Electrical)","Kisan Drone Operators","Drone Technician","Frontline Health Care Giving Assistant","Advanced Course in Computer Application (ACCA).","Course in Computer Application (CCA).","Course in Digital Accounting (CDA).","Course in Software Development (CSD).","Course in Designing and Publishing (CDP).","Course in Web Technology (CWT).","Computer Hardware & Networking Associate (CHNA).","Course in IT Foundation & Tools (CIFT).","Certificate Course in Computer Basics and Accounting (CCBA).","Certificate Course in Web Designing and Multimedia (CCWM).","Hardware Peripheral and Installation Assistant (HPIA).","Assistant PHP Developer (APD).","Digital Marketing Assistant (DMA).","Software / Application Testing Assistant (SATA).","Application Development Android (ADA).","Programming with Python (PWP).","Fundamentals of Computers (FC).","HKCL Certificate in Information Technology (HS-CIT).","HKCL Certificate in English Communication & Soft Skills.","HKCL Certificate in Data Entry Operator.","HKCL Course in Community Service Provider.","Solar PV Installer (Surya Mitra).","Solar PV Installer (Electrical)."]

  const stepTitles = [
    "PPP Verification",
    "Family Details",
    "Address Details",
    "Contact Information",
    "Educational & Military Details",
    "NSQF Course Selection", 
    "Undertaking & OTP", 
  ];
  const [step, setStep] = useState(0);
  const isFirst = step === 0;
  const isLast = step === stepTitles.length - 1;
  
  const goBack = () => {
    setStep((s) => Math.max(0, s - 1));
    setFormErrors({});
  };
  
  const goNext = () => {
    // Skip validation for the last step (OTP verification)
    if (step === stepTitles.length - 1) {
      setStep((s) => s + 1);
      return;
    }
    
    // Include additional form data that might be needed for validation
    const formDataForValidation = {
      ...formData,
      isExServiceman: isExServiceman === "Yes"
    };
    
    const { isValid, errors } = validateStep(step, formDataForValidation, qualificationDocs);
    
    if (isValid) {
      setFormErrors({});
      setStep((s) => Math.min(stepTitles.length - 1, s + 1));
      // Scroll to top after navigation
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      setFormErrors(errors);
      // Show the first error message
      const firstError = Object.values(errors)[0];
      if (firstError) {
        toast.error(firstError);
      }
      // Scroll to the first error
      const firstErrorElement = document.querySelector('.is-invalid');
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };
useEffect(() => {
  scrollToTop();
}, [step]);


  useEffect(() => {
    if (!shouldLoadForm || !formData.state) return;
    const fetchDistrict = async () => {
              dispatch(isloading());
      try {
        const res = await AxiosInstance.get(`${BaseUrl}/api/master/districts`, {
          params: { stateName: formData.state },
        });
        setDistricts(res.data);
      } catch (error) {
        handleAxiosError(error);
      }finally{
              dispatch(isloading());
            }
    };
    fetchDistrict();
  }, [formData.state, shouldLoadForm]);




  useEffect(() => {
    if (!shouldLoadForm || !formData.district) return;
    const fetchTehsil = async () => {
              dispatch(isloading());
      try {
        const res = await AxiosInstance.get(`${BaseUrl}/api/master/tehsils`, {
          params: { districtName: formData.district },
        });
        setTehsils(res.data);
      } catch (error) {
        handleAxiosError(error);
      }finally{
              dispatch(isloading());
            }
    };
    fetchTehsil();
  }, [formData.district, shouldLoadForm]);

  const fetchData = async () => {
    try {
      const res = await AxiosInstance.get(`${BaseUrl}/api/master/all`);
      
      if (res.data) {
        // Set states from single API response
        setStates(Array.isArray(res.data.states) ? res.data.states : []);
        
        // Set other data from single response
        setGenders(Array.isArray(res.data.gender) ? res.data.gender : []);
        setMaritalStatus(Array.isArray(res.data.maritalStatus) ? res.data.maritalStatus : []);
        
        // Set districts and tehsils for form functionality
        setDistricts(Array.isArray(res.data.districts) ? res.data.districts : []);
        setTehsils(Array.isArray(res.data.tehsils) ? res.data.tehsils : []);
      }
    } catch (error) {
      handleAxiosError(error);
    } finally {
      dispatch(isloading());
    }
  };

  useEffect(() => {
    if (!shouldLoadForm) return;
    dispatch(isloading());
    fetchData();
  }, [dispatch, shouldLoadForm]);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((p) => p - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // Handle pre-selected course from location state
  useEffect(() => {
    if (location.state?.selectedCourse) {
      setFormData(prev => ({
        ...prev,
        nsqfCourseId: location.state.selectedCourse
      }));
    }
  }, [location.state]);

 const handleChange = (e) => {
     const { name, value, type, checked } = e.target;
 
     if (!touchedFields[name]) {
       setTouchedFields(prev => ({ ...prev, [name]: true }));
     }
     if (formErrors[name]) {
       setFormErrors(prev => {
         const newErrors = { ...prev };
         delete newErrors[name];
         return newErrors;
       });
     }
 
     if (type === "checkbox") {
       setFormData((prev) => ({ ...prev, [name]: checked }));
       return;
     }
 
     let newValue = value;
 
     switch (name) {
       case 'fullName':
       case 'fatherName':
       case 'motherName':
         newValue = validateName(value);
         break;
         
       case (name.match(/^gradePercentage_/) || {}).input:
         // Allow only digits and one decimal point
         newValue = value.replace(/[^\d.]/g, '');
         
         // Handle multiple decimal points
         const parts = newValue.split('.');
         if (parts.length > 2) {
           newValue = `${parts[0]}.${parts[1]}`;
         }
         
         // Limit to 2 decimal places
         if (parts[1] && parts[1].length > 2) {
           newValue = `${parts[0]}.${parts[1].substring(0, 2)}`;
         }
         
         // Limit to 3 digits before decimal (for 100%)
         if (parts[0].length > 3) {
           newValue = parts[0].substring(0, 3) + (parts[1] ? `.${parts[1]}` : '');
         }
         
         // Ensure value doesn't exceed 100
         const numericValue = parseFloat(newValue);
         if (!isNaN(numericValue) && numericValue > 100) {
           newValue = '100';
           // Show error message if needed
           setFormErrors(prev => ({
             ...prev,
             [name]: 'Percentage cannot exceed 100%'
           }));
         } else if (formErrors[name]) {
           // Clear error if value is valid
           setFormErrors(prev => {
             const newErrors = { ...prev };
             delete newErrors[name];
             return newErrors;
           });
         }
         break;

       case (name.match(/^boardUniversity_/) || {}).input:
       case (name.match(/^instituteName_/) || {}).input:
       
         newValue = value.replace(/[^a-zA-Z\s]/g, '');
      
         newValue = newValue.replace(/\s+/g, ' ');
     
         if (newValue.length > 100) {
           newValue = newValue.substring(0, 100);
         }
         break;
         
       case 'mobile':
       case 'altMobile':
         newValue = validateNumeric(value, 10);
         break;
         
       case 'pinCode':
         newValue = validateNumeric(value, 6);
         break;
         
       case 'otp':
         newValue = validateNumeric(value, 6);
         break;
         
       case 'pppId':
       case 'memberId':
         newValue = validateAlphaNumeric(value);
         break;
         
       case 'address':
       case 'village':
         newValue = validateAddress(value);
         break;
         
       case 'email':
         break;
         
       default:
         break;
     }
 
     setFormData(prev => ({
       ...prev,
       [name]: newValue
     }));
   };

 const handleStateChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => {
    const updates = { 
      [name]: value,
      district: "",
      tehsil: "",
      village: "",
      pinCode: ""
    };
    return { ...prev, ...updates };
  });
  
  if (formErrors[name]) {
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[name];
      return newErrors;
    });
  }
};
  const handleMilitaryCourseFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const allowedTypes = ["application/pdf", "image/png", "image/jpeg"];
    const maxSizeInBytes = 1 * 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      toast.error("Invalid file type. Only PDF, PNG, and JPG are allowed.");
      e.target.value = "";
      setMilitaryCourseFile(null);
      setFormData(prev => ({
        ...prev,
        militaryCourseDocument: null
      }));
      return;
    }

    if (file.size > maxSizeInBytes) {
      toast.error("File size should not exceed 1MB.");
      e.target.value = "";
      setMilitaryCourseFile(null);
      setFormData(prev => ({
        ...prev,
        militaryCourseDocument: null
      }));
      return;
    }

    // Clear any existing error
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors.militaryCourseDocument;
      return newErrors;
    });

    setMilitaryCourseFile(file);
    setFormData(prev => ({
      ...prev,
      militaryCourseDocument: file
    }));
  };

  const handleQualificationFileChange = (e, qualification) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const allowedTypes = ["application/pdf", "image/png", "image/jpeg"];
    const maxSizeInBytes = 1 * 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      toast.error(`Invalid file type for ${qualification}. Only PDF, PNG, and JPG are allowed.`);
      e.target.value = "";
      setQualificationDocs(prev => ({
        ...prev,
        [qualification]: null
      }));
      return;
    }

    if (file.size > maxSizeInBytes) {
      toast.error(`File size for ${qualification} should not exceed 1MB.`);
      e.target.value = "";
      setQualificationDocs(prev => ({
        ...prev,
        [qualification]: null
      }));
      return;
    }

    // Clear any existing document error when a valid file is selected
    setFormErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[`document_${qualification}`];
      return newErrors;
    });

    setQualificationDocs(prev => ({
      ...prev,
      [qualification]: file
    }));
  };

  const removeQualificationDoc = (qualification) => {
    setQualificationDocs(prev => ({
      ...prev,
      [qualification]: null
    }));
    // Reset file input
    const input = document.getElementById(`doc-${qualification.replace(/\s+/g, '-')}`);
    if (input) input.value = '';
  };

  const sendOtp = async () => {
    const { mobile } = formData;
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      toast.error("Enter a valid 10-digit mobile number starting with 6-9");
      return;
    }
            dispatch(isloading());
    setIsSendingOtp(true);
    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/auth/send_otp`,
        { mobileNo: mobile },
        { headers: { "Content-Type": "application/json" } }
      );
      if (res.data && res.data.status === 200) {
        toast.success(res.data.message);
        setIsOtpSent(true);
        setTimer(60);
        setFormData((prev) => ({ ...prev, otp: "" }));
      } else {
        toast.error((res.data && res.data.message) || "Failed to send OTP");
      }
    } catch (err) {
      toast.error((err && err.response && err.response.data && err.response.data.message) || "Server error");
    } finally {
      setIsSendingOtp(false);
      setTimer(60);
      setFormData((prev) => ({ ...prev, otp: "" }));
              dispatch(isloading());
    }
  };

   const fetchFamilyMembers = async () => {
    if (!formData.pppId) {
      setPppErrors({ pppId: "PPP ID is required" });
      return;
    }
            dispatch(isloading());
    setPppErrors({});
    setPppSuccessMessage("");
    try {
      const response = await AxiosInstance.post(
        `${BaseUrl}/api/get-applications`, { familyId: formData.pppId },
       
      );
      
      if (response.data && response.data.status === 200) {
        setFamilyMembers(response.data.data || []);
        setPppSuccessMessage(response.data.message || "Family members fetched successfully");
      } else {
        setPppErrors({ fetchError: response.data?.message || "Failed to fetch family members" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit form. Please try again.");
    } finally {
      setIsSubmitting(false);
              dispatch(isloading());
    }
  };

  const sendPppOtp = async () => {
    if (!selectedMemberId) {
      setPppErrors({ selectedMemberId: "Please select a family member" });
      return;
    }
            dispatch(isloading());
    setPppErrors({});
    setPppSuccessMessage("");
    
    try {
      const response = await AxiosInstance.post(
        `${BaseUrl}/api/otp-request`,
        { 
          memberId: selectedMemberId 
        }
      );
      
      if (response.data && response.data.status === 200) {
        setPppOtpSent(true);
        setPppTxn(response.data?.data?.txn || "");
        setPppSuccessMessage(response.data?.data?.message || "OTP sent successfully");
      } else {
        setPppErrors({ otpError: response.data?.message || "Failed to send OTP" });
      }
    } catch (error) {
      const errorMessage = handleAxiosError(error);
      setPppErrors({ otpError: errorMessage });
    }finally{
            dispatch(isloading());
          }
  };

  const verifyPppOtp = async () => {
    if (pppOtp.length !== 6) {
      setPppErrors({ otp: "Please enter a valid 6-digit OTP" });
      return;
    }
    if (!pppTxn) {
      setPppErrors({ otp: "Transaction ID missing. Please request OTP again." });
      return;
    }
            dispatch(isloading());
    setPppErrors({});
    setPppSuccessMessage("");
    
    try {
      const response = await AxiosInstance.post(
        `${BaseUrl}/api/otp-validate`,
        {
          otp: pppOtp,
          txn: pppTxn,
          memberId: selectedMemberId
        }
      );
      
      if (response.data && response.data.status === 200) {
        setPppVerified(true);
        setPppOtp("");
        setFormData((prev) => ({ ...prev, memberId: selectedMemberId }));
        const successMessage = response.data.message || "PPP Verified Successfully";
        setPppSuccessMessage(successMessage);
        toast.success(successMessage);
      } else {
        const errorMessage = response.data?.message || "OTP verification failed";
        setPppErrors({ otp: errorMessage });
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMessage = handleAxiosError(error);
      setPppErrors({ otp: errorMessage });
      toast.error(errorMessage);
    }finally{
            dispatch(isloading());
          }
  };

  const resetPPPVerification = () => {
    setFormData((p) => ({ ...p, pppId: "", memberId: "" }));
    setFamilyMembers([]);
    setSelectedMemberId("");
    setPppOtp("");
    setPppOtpSent(false);
    setPppVerified(false);
    setPppSuccessMessage("");
    setPppErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!shouldLoadForm) {
      toast.error("Only ex-servicemen can register.");
      return;
    }
        dispatch(isloading());
    // Check if all qualifications have documents uploaded
    const missingDocs = [];
    Object.entries(qualificationDocs).forEach(([qual, file]) => {
      if (!file && formData[`boardUniversity_${qual}`]) {
        missingDocs.push(qual);
      }
    });

    if (missingDocs.length > 0) {
      toast.error(`Please upload documents for: ${missingDocs.join(', ')}`);
      return;
    }

    if (!pppVerified || !formData.memberId) {
      toast.error("Please complete PPP verification before registering.");
      return;
    }

    if (!formData.otp || formData.otp.length !== 6) {
      toast.error("Please enter the 6-digit OTP");
      return;
    }

    const submitData = new FormData();
    const toBool = (v) => String(v) === 'true' || v === true;
    const asNumberorEmpty = (v) => v !== "" && v != null ? String(Number(v)) : "";

    // Handle registration data (non-military, non-education fields)
    const registrationData = { ...formData };
    
    // Remove educational qualification fields
    const qualificationFields = ['8th', '10th', '12th', 'Graduation', 'Professional Course (if any)'];
    qualificationFields.forEach(qual => {
      delete registrationData[`boardUniversity_${qual}`];
      delete registrationData[`instituteName_${qual}`];
      delete registrationData[`gradePercentage_${qual}`];
    });

    // Remove military service and related fields
    const militaryFields = [
      'forceNumber', 'forceName', 'service', 'type', 'rank', 'medicalCategory', 
      'dischargeDate', 'dischargeBookNo', 'unitRetired',
      'militaryEnrollmentDate', 'militaryDischargeDate', 'militaryCourse'
    ];
    militaryFields.forEach(field => {
      delete registrationData[field];
    });

    // Add registration data
    Object.entries(registrationData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        submitData.append(`registration.${key}`, value);
      }
    });

    // Add educational qualifications as qualification[0], qualification[1], etc.
    let qualIndex = 0;
    
    // Add military course as a qualification if it exists
    if (formData.militaryCourse) {
      submitData.append(`registration.militaryCourseAttended`, formData.militaryCourse);
      submitData.append(`registration.dateOfEnrollment`, formData.militaryEnrollmentDate || '');
      submitData.append(`registration.dateOfDischarge`, formData.militaryDischargeDate || '');
      
        submitData.append(`registration.militaryCourseFile`, formData.militaryCourseDocument);
    
    }
    
    // Add regular educational qualifications
    qualificationFields.forEach((qual) => {
      if (formData[`boardUniversity_${qual}`]) {
        submitData.append(`qualification[${qualIndex}].type`, qual);
        submitData.append(`qualification[${qualIndex}].board`, formData[`boardUniversity_${qual}`] || '');
        submitData.append(`qualification[${qualIndex}].institutionName`, formData[`instituteName_${qual}`] || '');
        submitData.append(`qualification[${qualIndex}].percentage`, formData[`gradePercentage_${qual}`] || '');
        
        const docFile = qualificationDocs[qual];
        if (docFile) {
          submitData.append(`qualification[${qualIndex}].file`, docFile);
        }
        
        qualIndex++;
      }
    });

    // Add military service details
    const militaryService = {
      forceNumber: formData.forceNumber,
      forceName: formData.forceName,
      service: formData.service,
      type: formData.type,
      rank: formData.rank,
      medicalCategory: formData.medicalCategory,
      dischargeDate: formData.dischargeDate,
      dischargeBookNo: formData.dischargeBookNo,
      unitRetired: formData.unitRetired
    };

    Object.entries(militaryService).forEach(([key, value]) => {
      if (value) {
        submitData.append(`militaryService.${key}`, value);
      }
    });

    if (dischargeFile) {
      submitData.append("militaryService.dischargeDocument", dischargeFile);
    }

    try {
      const registerRes = await AxiosInstance.post(
        `${BaseUrl}/api/auth/save-skill-registration`,
        submitData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (registerRes.data && registerRes.data.status === 200) {
        toast.success("Registration successful!");
        //navigate("/login");
      } else {
        toast.error((registerRes.data && registerRes.data.message) || "Registration failed");
      }
    } catch (err) {
      toast.error((err?.response?.data?.message) || "Registration failed");
    }finally{
            dispatch(isloading());
          }
  };

  if (!shouldLoadForm) {
    return (
      <div className="container" >
        <div className="p-4 mx-5 my-4 shadow-lg rounded-3">
          <h2 className="mb-4 text-center" style={{ color: "grey" }}>
            Application for skill courses
          </h2>

          <div className="row justify-content-center">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">Are you an ex-serviceman?</label>
              <select
                className="form-select"
                value={isExServiceman}
                onChange={(e) => setIsExServiceman(e.target.value)}
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              {isExServiceman === "No" && (
                <div className="alert alert-info mt-3">
                  This application is currently available only for ex-servicemen.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

    const getMaxDate = () => {
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  return maxDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

  return (
    <div className="container" ref={topRef}>
      <div className="p-4 mx-5 my-4 shadow-lg rounded-3">
        <h2 className="mb-2 text-center" style={{ color: "grey" }}>
          Application for skill courses
        </h2>

        {/* Progress Header (UI only) */}
        <div className="text-center mb-3">
          <small className="text-muted">
            Step {step + 1} of {stepTitles.length} — <strong>{stepTitles[step]}</strong>
          </small>
          <div className="progress mt-2" role="progressbar" aria-valuenow={((step+1)/stepTitles.length)*100}>
            <div
              className="progress-bar"
              style={{ width: `${((step + 1) / stepTitles.length) * 100}%` }}
            />
          </div>
        </div>

        <form onSubmit={handleSubmit} encType="multipart/form-data" className="needs-validation">
          {/* STEP 0: PPP Verification */}
          {step === 0 && (
            <div className="mb-4 p-3 border rounded">
              <h5 className="mb-3 text-secondary">PPP Verification </h5>

              <div className="mb-3">
                       <div className="form-check mb-2">
    <input 
      type="checkbox" 
      className="form-check-input" 
      id="pppCheckbox"
      checked={formData.pppIdEnabled || false}
      onChange={(e) => {
        setFormData(p => ({ 
          ...p, 
          pppIdEnabled: e.target.checked,
          pppId: e.target.checked ? p.pppId : '' // Clear PPP ID when unchecked
        }));
      }}
    />
    <label className="form-check-label text-danger" htmlFor="pppCheckbox">
      I am willing to provide my PPP ID.
    </label>
  </div>
                <label className="form-label">PPP ID</label>
                <input
                  name="pppId"
                  maxLength={8}
                  className={`form-control ${pppErrors.pppId ? "is-invalid" : ""}`}
                  value={formData.pppId}
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, pppId: e.target.value }))
                  }
                  onKeyPress={(e) => {
                    if (!/[A-Za-z0-9]/.test(e.key)) e.preventDefault();
                  }}
                 disabled={!formData.pppIdEnabled || pppVerified}
                  placeholder={formData.pppIdEnabled ? "Enter PPP ID" : "Please check the box above to enter PPP ID"}
                  required={formData.pppIdEnabled}
                />
                {pppErrors.pppId && (
                  <div className="invalid-feedback">{pppErrors.pppId}</div>
                )}
              </div>

              {pppVerified && formData.memberId && (
                <div className="mb-3">
                  <label className="form-label">Member ID</label>
                  <input
                    type="text"
                    value={formData.memberId}
                    disabled
                    className="form-control bg-light"
                  />
                </div>
              )}

              <div className="mb-3 d-flex gap-2">
                <button
                  type="button"
                  onClick={fetchFamilyMembers}
                  disabled={familyMembers.length > 0 || pppVerified || !formData.pppId}
                  className="btn btn-primary btn-md w-auto"
                >
                  Fetch Family Members
                </button>

                {pppVerified && (
                  <button
                    type="button"
                    onClick={resetPPPVerification}
                    className="btn btn-success btn-md w-auto"
                  >
                    Reset PPP
                  </button>
                )}
              </div>

              {familyMembers.length > 0 && (
                <>
                  <div className="mb-3">
                    <label className="form-label">Select Family Member</label>
                    <select
                      value={selectedMemberId}
                      onChange={(e) => setSelectedMemberId(e.target.value)}
                      disabled={pppOtpSent || pppVerified}
                      className={`form-select ${
                        pppErrors.selectedMemberId ? "is-invalid" : ""
                      }`}
                    >
                      <option value="">-- Select Member --</option>
                      {familyMembers.map((m) => (
                        <option key={m.value} value={m.value}>
                          {m.text}
                        </option>
                      ))}
                    </select>
                    {pppErrors.selectedMemberId && (
                      <div className="invalid-feedback">
                        {pppErrors.selectedMemberId}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <button
                      type="button"
                      onClick={sendPppOtp}
                      disabled={pppOtpSent || pppVerified || !selectedMemberId}
                      className="btn btn-primary btn-md w-auto"
                    >
                      {pppOtpSent ? "OTP Sent" : "Send OTP "}
                    </button>
                  </div>
                </>
              )}

              {pppOtpSent && !pppVerified && (
                <div className="mb-3">
                  <label className="form-label">Enter OTP</label>
                  <input
                    type="text"
                    maxLength={6}
                    className={`form-control ${pppErrors.otp ? "is-invalid" : ""}`}
                    placeholder="Enter OTP "
                    value={pppOtp}
                    onChange={(e) => setPppOtp(validateNumeric(e.target.value, 6))}
                  />
                  {pppErrors.otp && (
                    <div className="invalid-feedback">{pppErrors.otp}</div>
                  )}

                  <button
                    type="button"
                    onClick={verifyPppOtp}
                    disabled={!pppOtp}
                    className="btn btn-primary mt-2 btn-md w-auto"
                  >
                    Verify OTP 
                  </button>
                </div>
              )}

              {pppSuccessMessage && pppVerified &&(
                <p className="text-success fw-medium">✅ {pppSuccessMessage}</p>
              )}
            </div>
          )}

          {/* STEP 1: Family Details */}
          {step === 1 && (
            <>
              <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Family Details
              </h5>
              <div className="row">
                <div className="col-md-6">
                  <FormField
                    label="Full Name"
                    name="fullName"
                    type="text"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                    error={formErrors.fullName}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Father's Name"
                    name="fatherName"
                    type="text"
                    value={formData.fatherName}
                    onChange={handleChange}
                    placeholder="Enter father's name"
                    required
                    error={formErrors.fatherName}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Mother's Name"
                    name="motherName"
                    type="text"
                    value={formData.motherName}
                    onChange={handleChange}
                    placeholder="Enter mother's name"
                    required
                    error={formErrors.motherName}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Date of Birth"
                    name="dob"
                    type="date"
                    value={formData.dob}
                    onChange={handleChange}
                    max={getMaxDate()}
                    required
                    placeholder="Select date of birth"
                    error={formErrors.dob}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Gender"
                    name="gender"
                    type="select"
                    value={formData.gender || ""}
                    onChange={handleChange}
                    placeholder="Select gender"
                    required
                    error={formErrors.gender}
                    options={[
                      ...genders.map(g => ({ value: g, label: g }))
                    ]}
                  />
                </div>

                <div className="col-md-6">
                  <FormField
                    label="Marital Status"
                    name="maritalStatus"
                    type="select"
                    value={formData.maritalStatus || ""}
                    onChange={handleChange}
                    placeholder="Select marital status"
                    required
                    error={formErrors.maritalStatus}
                    options={[
                      ...maritalStatus.map(m => ({ value: m, label: m }))
                    ]}
                  />
                </div>
              </div>
            </>
          )}

          {/* STEP 2: Address Details */}
          {step === 2 && (
            <>
              <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Address Details
              </h5>
              <div className="row">
                <div className="col-md-6">
                  <FormField
                    label="State"
                    name="state"
                    type="select"
                    value={formData.state}
                    onChange={handleStateChange}
                    required
                    error={formErrors.state}
                    options={[
                      ...(states?.map(state => ({ value: state.code, label: state.name })) || [])
                    ]}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="District"
                    name="district"
                    type="select"
                    value={formData.district}
                    onChange={handleChange}
                    required
                    disabled={!formData.state}
                    error={formErrors.district}
                    options={[
                      ...(districts?.map(dist => ({ value: dist.code, label: dist.name })) || [])
                    ]}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Tehsil"
                    name="tehsil"
                    type="select"
                    value={formData.tehsil}
                    onChange={handleChange}
                    required
                    disabled={!formData.district}
                    error={formErrors.tehsil}
                    options={[
                      ...(tehsils?.map(tehsil => ({ value: tehsil.code, label: tehsil.name })) || [])
                    ]}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Village/Ward No/Colony"
                    name="village"
                    type="text"
                    value={formData.village}
                    onChange={handleChange}
                    placeholder="Enter village/ward/colony name"
                    required
                    error={formErrors.village}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Permanent Home Address"
                    name="address"
                    type="textarea"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Enter your complete address"
                    rows={3}
                    required
                    error={formErrors.address}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="PIN Code"
                    name="pinCode"
                    type="text"
                    value={formData.pinCode}
                    onChange={handleChange}
                    placeholder="Enter 6-digit PIN code"
                    maxLength={6}
                    required
                    error={formErrors.pinCode}
                  />
                </div>
              </div>
            </>
          )}

          {/* STEP 3: Contact Information */}
          {step === 3 && (
            <>
              <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Contact Information
              </h5>
              <div className="row">
                <div className="col-md-6">
                  <FormField
                    label="Email ID"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    required
                    error={formErrors.email}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Mobile Number"
                    name="mobile"
                    type="tel"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Enter 10-digit mobile number"
                    maxLength={10}
                    required
                    error={formErrors.mobile}
                  />
                </div>
                <div className="col-md-6">
                  <FormField
                    label="Alternate Mobile Number"
                    name="altMobile"
                    type="tel"
                    value={formData.altMobile}
                    onChange={handleChange}
                    placeholder="Enter alternate mobile number (optional)"
                    maxLength={10}
                    error={formErrors.altMobile}
                  />
                </div>
              </div>
            </>
          )}

        {step === 4 && (
  <>
 
<h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Educational Qualifications
              </h5>

    <div className="table-responsive mb-4">
      <table className="table table-bordered align-middle">
        <thead className="table-light text-center">
          <tr>
            <th>Qualification</th>
            <th>Board / University</th>
            <th>School / College Name</th>
            <th>Percentage</th>
            <th>Document</th>
          </tr>
        </thead>
        <tbody>
          {[
            "8th",
            "10th",
            "12th",
            "Graduation",
            "Professional Course (if any)",
          ].map((q) => (
            <tr key={q}>
              <td className="fw-semibold">{q}</td>

              <td>
                <FormField
                  name={`boardUniversity_${q}`}
                  type="text"
                  value={formData[`boardUniversity_${q}`] || ""}
                  onChange={handleChange}
                  placeholder="Board / University"
                  className="mb-0"
                  error={formErrors[`boardUniversity_${q}`]}
                />
              </td>

              <td>
                <FormField
                  name={`instituteName_${q}`}
                  type="text"
                  value={formData[`instituteName_${q}`] || ""}
                  onChange={handleChange}
                  placeholder="School / College"
                  className="mb-0"
                  error={formErrors[`instituteName_${q}`]}
                />
              </td>

              <td>
                <FormField
                  name={`gradePercentage_${q}`}
                  type="text"
                  value={formData[`gradePercentage_${q}`] || ""}
                  onChange={handleChange}
                  placeholder="e.g. 75% / CGPA"
                  className="mb-0"
                  disabled={!formData[`boardUniversity_${q}`]}
                  error={formErrors[`gradePercentage_${q}`]}
                />
              </td>
              <td>
                <div className="d-flex flex-column">
                  <input
                    type="file"
                    id={`doc-${q.replace(/\s+/g, '-')}`}
                    className="form-control form-control mb-3"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handleQualificationFileChange(e, q)}
                    disabled={!formData[`boardUniversity_${q}`]}
                  />
                  {qualificationDocs[q] && (
                    <div className="">
                      <small className="text-success">
                        
                        {qualificationDocs[q].name}
                        
                      </small>
                    </div>
                  )}
                  {formErrors[`document_${q}`] && (
                    <div className="invalid-feedback d-block">
                      {formErrors[`document_${q}`]}
                    </div>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Military Service Details */}
    <h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Military Service Courses Details (Optional)
              </h5>

    <div className="table-responsive">
      <table className="table table-bordered align-middle">
        <thead className="table-light text-center">
          <tr>
            <th>Date of Enrollment</th>
            <th>Date of Discharge</th>
            <th>Military Course Attended</th>
            <th>Course Certificate (Scan Copy)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <FormField
                name="militaryEnrollmentDate"
                type="date"
                value={formData.militaryEnrollmentDate || ""}
                onChange={handleChange}
                className="mb-0"
                error={formErrors.militaryEnrollmentDate}
              />
            </td>

            <td>
              <FormField
                name="militaryDischargeDate"
                type="date"
                value={formData.militaryDischargeDate || ""}
                onChange={handleChange}
                className="mb-0"
                min={formData.militaryEnrollmentDate || ''}
                error={formErrors.militaryDischargeDate}
              />
            </td>

            <td>
              <FormField
                name="militaryCourse"
                type="text"
                value={formData.militaryCourse || ""}
                onChange={handleChange}
                placeholder="Course name"
                className="mb-0"
                error={formErrors.militaryCourse}
              />
            </td>

            <td>
              <div className="d-flex flex-column">
                <input
                  type="file"
                  id="militaryCourseDocument"
                  className="form-control mb-3"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleMilitaryCourseFileChange}
                />
              {militaryCourseFile && (
            <div className="d-flex align-items-center">
              <small className="text-success me-2">
                {militaryCourseFile.name}
                <a 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setMilitaryCourseFile(null);
                    document.getElementById('militaryCourseDocument').value = '';
                    setFormData(prev => ({
                      ...prev,
                      militaryCourseDocument: null
                    }));
                  }}
                  className="ms-2 text-danger text-decoration-none"
                  title="Remove file"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </a>
              </small>
            </div>
          )}
                {formErrors.militaryCourseDocument && (
                  <div className="invalid-feedback d-block">
                    {formErrors.militaryCourseDocument}
                  </div>
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </>
)}


        {/* STEP 5: NSQF Course Selection */}
{step === 5 && (
  <>
    
<h5 className="mb-3 mt-4 border-bottom pb-2 text-secondary border-info">
                Course Selection
              </h5>
    {/* Course Selection Table */}
    <div className="table-responsive mb-4">
      <table className="table table-bordered align-middle text-center">
        <thead className="table-light">
          <tr>
            <th style={{ width: "40%" }}>Course Name</th>
            <th>Total No. of Seats</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <FormField
                name="nsqfCourseId"
                type="select"
                value={formData.nsqfCourseId || ""}
                onChange={handleChange}
                required
                error={formErrors.nsqfCourseId}
                options={[
                  { value: '', label: 'Select NSQF Course', disabled: true },
                  ...skillCourses.map(course => ({ value: course, label: course }))
                ]}
                className="w-100"
              />
            </td>

            <td>
              100
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    
  </>
)}
{step === 6 && (
            <>
              <ul className="my-4 me-4 " style={{  listStyleType: "decimal",textAlign: "justify",color:"#ca2525"}}>
                <li className="">I have carefully read and checked all the particulars filled up by me against each column above and thereafter saved the same. I fully understandthat if any of these is found false/incorrect then my application form, candidature or appointment shall be liable to be rejected/cancelled.</li>
                <li className="text-justify">I understand and affirm that deployment in a government entity would be governed by the provisions of “Deployment of Contractual PersonsPolicy, 2022” and that appointment in a private entity would be governed by the conditions of the Indent/requisition/Selection criteria specified bythe Indenting Private Sector Entity.</li>
                <li className="">I understand that the for deployment in a government entity “age criteria” as per the provisions of “Deployment of Contractual Persons Policy,2022” shall be applicable and for appointment in Private Sector, “Age Criteria” requirement as per the Indent/Requirement of Indenting PrivateSector Entity shall be applicable.</li>
                <li className="">I understand that for deployment in a government entity, only prior verified government experience would be taken into consideration and in caseof appointment in a private entity, prior experience would be taken into consideration subject to its verification.</li>
              </ul>

              {isOtpSent && (
                <div className="row">
                  <div className="col-md-6 mb-3 mx-auto">
                    <label className="form-label">OTP</label>
                    <input
                      type="text"
                      className="form-control"
                      name="otp"
                      value={formData.otp}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              )}

              <div className="text-center mx-auto">
                {!isOtpSent ? (
                  <button
                    type="button"
                    className="btn btn-primary btn-md w-auto"
                    onClick={sendOtp}
                    disabled={false}
                  >
                    {isSendingOtp ? "Sending OTP..." : "Submit & Send OTP"}
                  </button>
                ) : (
                  <div className="d-flex justify-content-center mt-1">
                    <button type="submit" className="btn btn-success w-auto btn-md">
                      Register
                    </button>
                    <button
                      type="button"
                      className="btn btn-warning ms-4 w-auto btn-md"
                      onClick={sendOtp}
                      disabled={timer > 0}
                    >
                      {timer > 0 ? `Resend OTP (${timer}s)` : "Resend OTP"}
                    </button>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Wizard Controls */}
          <div className="d-flex justify-content-between mt-4">
            <div>
              {!isFirst && (
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-md w-auto"
                  onClick={goBack}
                >
                  Back
                </button>
              )}
            </div>
            <div>
              {!isLast && (<button
                type="button"
                className="btn btn-primary btn-md w-auto"
                onClick={goNext}
              >
               Next
              </button>
              )}
            </div>
          </div>
        </form>
      </div>

     
    </div>
  );
};

export default SkillCourses;
